import { backendClient } from '@neptune/shared/core-apis-backend-domain';

export type GetProjectsForOrganizationParams = {
  username?: string;
  organizationIdentifier: string;
  isTeam: boolean;
  searchTerm?: string;
  sortBy?: string[];
  sortDirection?: string[];
  offset?: number;
  limit?: number;
};

/** @deprecated use getProjectsForOrganization, however note that there is another API */
export function getProjectsForOrganizationLegacy(params: GetProjectsForOrganizationParams) {
  const { username, isTeam, organizationIdentifier, ...restParams } = params;

  if (isTeam || !username) {
    return backendClient.listOrganizationProjects({
      organizationIdentifier,
      ...restParams,
    });
  }

  return backendClient.listUserProjects({
    projectsForUserMode: 'usersOrganizationIndividual',
    viewedUsername: username,
    ...restParams,
  });
}
